module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Deer-03510878412aa4c2a4452dbc4e32ca348e8086dc3d2ab7452eec194ea2fb4027.svg";